import {
  LOADING_SCREEN_LOADING_TEXT,
  PROPERTY_DETAILS_TAB_NAMES,
  datasetTypes,
} from '@/constants';
import { Record } from 'immutable';
import { IDashboardReduxState, IPermitContext } from './dashboard-types';

export const PermitContextFactory = Record<IPermitContext>({
  licenseNumber: null,
});

export const DashboardStateFactory = Record<IDashboardReduxState>({
  loadingText: LOADING_SCREEN_LOADING_TEXT,
  dashboardReady: false,
  selectedSidebarItems: [
    datasetTypes.UNIT_TYPE,
    datasetTypes.RESIDENTIAL_TYPE,
    datasetTypes.ONLINE_PLATFORMS,
    datasetTypes.RENTAL_SIZE,
  ],
  permitContext: new PermitContextFactory(),
  isUniversalSearchActive: false,
  activePropertyDetailsTab: PROPERTY_DETAILS_TAB_NAMES.overview,
});
